/*@ngInject*/
const UILogoDirective = function ($compile, $window, $rootScope, coreMediator) {

    let linkFunction = function ($scope, $elm) {

        function setupLogo() {
            const element = $($elm);

            if (!_.isEmpty($scope.logoConfiguredFileName)) {
                coreMediator.getConfiguredFile($scope.logoConfiguredFileName).then(function (configuredFile) {
                    if (!_.isEmpty(configuredFile)) {
                        coreMediator.getConfiguredFileData(configuredFile.id).then(function (data) {
                            const source = `data:${configuredFile.mimeType};base64,${data}`;
                            const img = angular.element(`<img src="${source}"/>`);
                            $compile(img)($scope);
                            element.html(img);
                        });
                    }
                });
            } else if (!_.isEmpty($scope.logoUrl)) {
                const img = angular.element(`<img src="${$scope.logoUrl}"/>`);
                $compile(img)($scope);
                element.html(img);
            }
        }

        $scope.$watch('logoConfiguredFileName', function () {
            setupLogo();
        });
    };

    return {
        restrict: 'A',
        link: linkFunction,
        scope: {
            logoConfiguredFileName: '@',
            logoUrl: '@'
        }
    };
};

angular.module('umCore')
    .directive('uiLogo', UILogoDirective);
